import type { ReactNode } from 'react';

/**
 * Un aviso. Los de error son `role="alert"` para que el lector de pantalla
 * los anuncie sin que la persona tenga que ir a buscarlos; los demás son
 * `status`, que se anuncia sin interrumpir lo que se esté leyendo.
 */
export function Alert({
  kind,
  children,
}: {
  kind: 'error' | 'success' | 'info';
  children: ReactNode;
}): JSX.Element {
  return (
    <div className={`alert ${kind}`} role={kind === 'error' ? 'alert' : 'status'}>
      {children}
    </div>
  );
}
